export var OngletsDefaultProps = {
    ongletActif: 0,
};
